import { PtErr } from "./throwErrorF/sharedErrF.mts";
export const json1ParseCatch = (str, onErr) => {
    try {
        return JSON.parse(str);
    }
    catch (ee) {
        if (onErr)
            onErr(ee);
        return undefined;
    }
};
export const json1Parse = (str) => {
    return json1ParseCatch(str, (err) => {
        throw new PtErr('!json1Parse', { str, err });
    });
};
